
import React from 'react';
import PlanInfoComponent from './plan-info.component';
import PlanSmsInfoComponent from './plan-note-info.component';
import PlanEmailInfoComponent from './plan-email-info.component';
import PlanWhatsappInfoComponent from './plan-whatsapp-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { EmailMarketingPlansComponent } from './email/email-marketing-plans.component';
import PlanFacebooksappInfoComponent from './plan-facebook-info.component';
import { PlanSMSTemplateInfoComponent } from './sms/sms-marketing-plans.component';


export const PlanComponent = ({
  handleInnerWhatsappFormChange,
  handleInnerEmailFormChange,
  handleInnerSMSFormChange,
  campaignFrequency,
  whatsappNotes,
  whatsappBudget,
  choosenWhatsappPlan,
  emailNotes,
  emailBudget,
  choosenEmailPlan,
  smsNotes,
  smsBudget,
  choosenSmsPlan,
  planNotes,
  handleInnerFormChange,
  back,
  handleSubmit,
  customerTags,
  choosenPlan,
  planBudget,
  id
}: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'OverView',
      component: <PlanInfoComponent
        campaignFrequency={campaignFrequency}
        customerTags={customerTags}
        choosenPlan={choosenPlan}
        planBudget={planBudget}
        planNotes={planNotes}
        handleInnerFormChange={handleInnerFormChange}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'SMS',
      component: <PlanSMSTemplateInfoComponent
        campaignFrequency={campaignFrequency}
        choosenSmsPlan={choosenSmsPlan}
        smsBudget={smsBudget}
        smsNotes={smsNotes}
        handleInnerFormChange={handleInnerSMSFormChange}
        customerTags={customerTags}
          choosenPlan={choosenPlan}
      />,
      isVisible: (id >0 && choosenPlan.IsSMSCampaignIncluded )? true : false,
    },
    {
      id: 3,
      title: 'Email',
      component: <EmailMarketingPlansComponent
        choosenPlan={choosenPlan}
        campaignFrequency={campaignFrequency}
        choosenEmailPlan={choosenEmailPlan}
        emailBudget={emailBudget}
        emailNotes={emailNotes}
        handleInnerEmailFormChange={handleInnerEmailFormChange}
        customerTags={customerTags}
        id={id}
      />,
      isVisible: (id>0 && choosenPlan.IsEmailCampaignIncluded) ? true : false,
    },
    // {
    //   id: 4,
    //   title: 'WhatsApp',
    //   component: <PlanWhatsappInfoComponent
    //     campaignFrequency={campaignFrequency}
    //     choosenWhatsappPlan={choosenWhatsappPlan}
    //     whatsappBudget={whatsappBudget}
    //     whatsappNotes={whatsappNotes}
    //     handleInnerFormChange={handleInnerWhatsappFormChange}
    //     customerTags={customerTags}
    //   />,
    //   isVisible: (id>0 && choosenPlan.IsWhatsappCampaignIncluded)  ? true : false,
    // },
    // {
    //   id: 4,
    //   title: 'Facebook',
    //   component: <PlanFacebooksappInfoComponent
    //     campaignFrequency={campaignFrequency}
    //     choosenWhatsappPlan={choosenWhatsappPlan}
    //     whatsappBudget={whatsappBudget}
    //     whatsappNotes={whatsappNotes}
    //     handleInnerFormChange={handleInnerWhatsappFormChange}
    //     customerTags={customerTags}
    //   />,
    //   isVisible: (id>0 && choosenPlan.IsFacebookCampaignIncluded)? true : false,
    // }

  ]

  return (
    <>
      
    <TabContainer tabItems={tabItems} />
     
          <div className="text-end">
          <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
            Back
            </button>
            <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleSubmit}
          
            type="submit"
        >
          Save
        </button>
          </div>
            </>
  );
};
export default PlanComponent;
